import { styled } from '@mui/material/styles';
import { HashLink as ReactHashLink } from 'react-router-hash-link';

export const ListItem = styled('li')(() => ({
  display: 'flex',
  alignItems: 'center',
  paddingRight: '16px',
}));

export const HashLink = styled(ReactHashLink)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none',
  color: 'black',
  '&:hover': {
    color: 'gray',
  },
}));